// These are the suffixes for the verbs in -ódik.
export const odikSuffixes1 = [
	"ódom",
	"ódsz",
	"ódik",
	"ódunk",
	"ódtok",
	"ódnak",
	"ódtam",
	"ódtál",
	"ódott",
	"ódtunk",
	"ódtatok",
	"ódtak",
	"ódjak",
	"ódj",
	"ódjon",
	"ódjunk",
	"ódjatok",
	"ódjanak",
	"ódnék",
	"ódnál",
	"ódna",
	"ódnánk",
	"ódnátok",
	"ódnának",
];
// These are the suffixes for the verbs in -ődik.
export const odikSuffixes2 = [
	"ődöm",
	"ődsz",
	"ődik",
	"ődünk",
	"ődtök",
	"ődnek",
	"ődtem",
	"ődtél",
	"ődött",
	"ődtünk",
	"ődtetek",
	"ődtek",
	"ődjek",
	"ődj",
	"ődjön",
	"ődjünk",
	"ődjetek",
	"ődjenek",
	"ődnék",
	"ődnél",
	"ődne",
	"dnénk",
	"ődnétek",
	"ődnének",
];

export const verbPrefixes = [
	"abba",
	"agyon",
	"alul",
	"alá",
	"alább",
	"által",
	"át",
	"be",
	"bele",
	"belé",
	"benn",
	"egybe",
	"együtt",
	"el",
	"ellen",
	"elő",
	"előre",
	"észre",
	"fel",
	"föl",
	"félbe",
	"félre",
	"felül",
	"fölül",
	"fenn",
	"fönn",
	"hátra",
	"haza",
	"helyre",
	"hozzá",
	"ide",
	"jóvá",
	"keresztül",
	"ketté",
	"ki",
	"kölcsön",
	"körül",
	"körbe",
	"közbe",
	"közre",
	"közzé",
	"külön",
	"le",
	"létre",
	"meg",
	"mellé",
	"neki",
	"oda",
	"össze",
	"rá",
	"rajta",
	"széjjel",
	"szembe",
	"szerte",
	"szét",
	"tele",
	"teli",
	"tova",
	"tovább",
	"tönkre",
	"utol",
	"túl",
	"újjá",
	"újra",
	"utána",
	"végbe",
	"végig",
	"vissza",
];
